<template>
    <div class="js-accordion translator-accordion" data-testid="accordion-other-translations">
        <h3 class="js-accordion__header translator-accordion__header" data-testid="accordion-other-translations-header"
            :aria-expanded="isOpen" @click="toggleAccordion" @keydown.enter.prevent="toggleAccordion"
            @keydown.space.prevent="toggleAccordion" :class="{ collapsed: !isOpen }"
            style="display: flex; margin-bottom: 0px;">
            {{ messages.accordionOtherTranslations }} ({{ sortedAutresTraductions.length }})
            <svg class="svg-icon svg-angle-down" aria-hidden="true" focusable="false">
                <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#angle-down"></use>
            </svg>
        </h3>

        <div v-show="isOpen" class="js-accordion__panel translator-accordion__panel">
            <ul class="list-unstyled mb-0" data-testid="other-translations-list">
                <li v-for="(t, index) in sortedAutresTraductions" :key="`${t.terme}-${index}`"
                    :data-testid="'other-translation-item-' + index"
                    :class="index < sortedAutresTraductions.length - 1 ? 'border-bottom py-0' : 'mb-0 py-0'">
                    <div class="other-translation-row">
                        <span v-if="t.score !== undefined" :class="['badge', 'badge-pill', badgeClass(t.score)]"
                            class="score-badge">
                            {{ formatScore(t.score) }}
                        </span>
                        <span class="term-label">{{ t.terme }}</span>
                        <div class="actions-group">
                            <translator-thumb-vote-output v-model="thumbVotes[index]" :show="true"
                                :modal-id="'modalProposerTraductionAlt' + index" :input-text="inputText"
                                :translated-text="t.terme" :highlighted-terms="[]"
                                :translation-score="t.score !== undefined ? t.score : null" :ordre="index + 2"
                                :model-id="modelId" :direction="direction" />
                            <button type="button"
                                class="v-icon notranslate v-icon--link mdi mdi-content-copy theme--light primary--text copy-btn"
                                :data-testid="'copy-alt-btn-' + index" @click="copyAlt(t.terme, index)"
                                :title="copiedAltIndex === index ? messages.copiedAltTitle : messages.copyAltTitle">
                            </button>
                        </div>
                    </div>
                </li>
                <li v-if="sortedAutresTraductions.length === 0" class="text-muted text-center py-2"
                    data-testid="other-translations-empty">
                    <small>{{ messages.noOtherTranslations }}</small>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import translatorConfig from '../config/translator.config.js';
import TranslatorThumbVoteOutput from './TranslatorThumbVoteOutput.vue';
import { badgeClass, formatScore } from '../utils/translatorUtils.js';
import Store from '../store-translator.js';

export default {
    name: 'TranslatorOthersTradsOutput',
    components: { TranslatorThumbVoteOutput },
    props: {
        autresTraductions: {
            type: Array,
            default: () => []
        },
        inputText: {
            type: String,
            default: ''
        },
        modelId: {
            type: String,
            default: null
        },
        direction: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            messages: translatorConfig.output.messages,
            copiedAltIndex: null,
            isOpen: false,
            thumbVotes: []
        }
    },
    computed: {
        sortedAutresTraductions() {
            return [...this.autresTraductions].sort((a, b) => {
                const scoreA = Number.isFinite(Number(a?.score)) ? Number(a.score) : -Infinity
                const scoreB = Number.isFinite(Number(b?.score)) ? Number(b.score) : -Infinity
                return scoreB - scoreA
            })
        }
    },
    methods: {
        badgeClass,
        formatScore,
        toggleAccordion() {
            this.isOpen = !this.isOpen
        },
        async copyAlt(terme, index) {
            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(terme)
                } catch {
                    this.fallbackCopy(terme)
                }
            } else {
                this.fallbackCopy(terme)
            }
            this.copiedAltIndex = index
            setTimeout(() => { this.copiedAltIndex = null }, 2000)
            Store.setSuccessMessage(this.messages.copiedConfirmation)
        },
        fallbackCopy(text) {
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.style.position = 'fixed'
            textarea.style.opacity = '0'
            document.body.appendChild(textarea)
            textarea.focus()
            textarea.select()
            document.execCommand('copy')
            textarea.remove()

        }
    }
}
</script>

<style scoped>
.other-translation-row {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    width: 100%;
}

.score-badge {
    margin-right: 0.25rem;
    flex-shrink: 0;
}

.term-label {
    flex: 1 1 auto;
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.actions-group {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    flex-shrink: 0;
}

.copy-btn {
    font-size: 1.25rem;
    flex-shrink: 0;
}
</style>
